import { parseISO, format } from 'date-fns';
import i18n from 'i18next';

import { getDateFnsLocale } from './dateFnsLocale';

export const DATE_FORMATS = {
  default: 'dd MMM HH:mm:ss',
  withYear: 'dd MMM yyyy HH:mm:ss',
  short: 'dd.MM.yyyy',
} as const;

const getLocale = () => getDateFnsLocale(i18n.language);

type DateInput = string | Date | undefined;

export const parseISOToLocale = (date: DateInput): string | undefined => {
  if (!date) return undefined;

  const parsed = typeof date === 'string' ? parseISO(date) : date;
  return parsed.toLocaleString();
};

export const formatDateTime = (
  date: DateInput,
  dateFormat: string = DATE_FORMATS.default,
): string | undefined => {
  if (!date) return undefined;

  const parsed = typeof date === 'string' ? parseISO(date) : date;

  return format(parsed, dateFormat, {
    locale: getLocale(),
  });
};
